import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IMealtime } from 'src/types/mealtimes.types';
import { ICreateMealtimeRequest, ICreateMealtimeResponse } from './types';

export const createMealtime = async (menuId: string, requestBody: ICreateMealtimeRequest): Promise<IMealtime> => {
  try {
    const response = await fetch(`${API_URL}/menus/${menuId}/mealtimes`, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error();
    }

    const { data }: ICreateMealtimeResponse = await response.json();
    return data[0];
  } catch (e) {
    throw new Error('Something went wrong whilst creating a mealtime');
  }
};
